import React from "react";
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import LockRoundedIcon from '@material-ui/icons/LockRounded';
import { formatPrice } from "../shared/pricing";
import "./HomeSections.css";

const scrollToRegEntry = () => {
  const targetSection = document.getElementById("enter-reg");
  if (targetSection) {
    targetSection.scrollIntoView({ behavior: "smooth", block: "center" });
  }
};

const PromoElements = (props) => {
  const plan = props.d;
  const featured = plan.featured;

  return (
    <div className="col-lg-6 col-md-6 col-12 mt-4" key={props.i}>
      <div className={featured ? "rc-plan rc-plan--featured" : "rc-plan"}>
        {featured && <div className="rc-plan-badge">MOST POPULAR</div>}

        <div className="rc-plan-name">{plan.prod_type}</div>
        <div className="rc-plan-price">
          {featured ? formatPrice(props.price) : "Free"}
        </div>
        <p className="rc-plan-strap">{plan.strap}</p>

        <ul className="rc-plan-list">
          {plan.options && plan.options.map((option, i) => {
            return (
              <li key={i} className={option.available ? "" : "is-locked"}>
                {option.available
                  ? <CheckCircleRoundedIcon className="rc-icon-yes" fontSize="small" />
                  : <LockRoundedIcon className="rc-icon-locked" fontSize="small" />}
                <span>{option.item}</span>
              </li>
            );
          })}
        </ul>

        <button
          type="button"
          onClick={scrollToRegEntry}
          className={featured ? "rc-cta" : "rc-cta rc-cta--ghost"}
        >
          {plan.cta}
        </button>
      </div>
    </div>
  );
};

export default PromoElements;
